numeral = require 'numeral'

numeral.language 'en-IE',
  delimiters:
    thousands: ' ',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return number is 1 ? 'st' : 'nd'
  currency:
    symbol: '€'


numeral.language 'en-CA',
  delimiters:
    thousands: ' ',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return number is 1 ? 'st' : 'nd'
  currency:
    symbol: '$'

numeral.language 'en-KW',
  delimiters:
    thousands: ' ',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return number is 1 ? 'st' : 'nd'
  currency:
    symbol: 'KD'

numeral.language 'en-SG',
  delimiters:
    thousands: ' ',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return number is 1 ? 'st' : 'nd'
  currency:
    symbol: '$'

numeral.language 'en-NZ',
  delimiters:
    thousands: ' ',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return number is 1 ? 'st' : 'nd'
  currency:
    symbol: '$'

numeral.language 'en-AU',
  delimiters:
    thousands: ' ',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return number is 1 ? 'st' : 'nd'
  currency:
    symbol: '$'


numeral.language 'nl', require 'numeral/languages/nl-nl'
numeral.language 'nl-BE', require 'numeral/languages/nl-nl'
numeral.language 'fr-BE', require 'numeral/languages/fr'

numeral.language 'en-NL',
  delimiters:
    thousands: ' ',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return number is 1 ? 'st' : 'nd'
  currency:
    symbol: '€'

numeral.language 'en-MT',
  delimiters:
    thousands: ' ',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return number is 1 ? 'st' : 'nd'
  currency:
    symbol: '€'

numeral.language 'ja',
  delimiters:
    thousands: ',',
    decimal: '.'
  abbreviations:
    thousand: '千',
    million: '百万',
    billion: '十億',
    trillion: '兆'
  ordinal: (number) ->
    return '.'
  currency:
    symbol: '¥'

numeral.language 'en-gb',
  delimiters:
    thousands: ',',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return (~~ (number % 100 / 10) == 1) ? 'th' : (b == 1) ? 'st' : (b == 2) ? 'nd' : (b == 3) ? 'rd' : 'th'
  currency:
    symbol: '£'

numeral.language 'en-AE',
  delimiters:
    thousands: ' ',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return number is 1 ? 'st' : 'nd'
  currency:
    symbol: '$'

numeral.language 'es-MX',
  delimiters:
    thousands: ' ',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'mm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return number is 1 ? 'st' : 'nd'
  currency:
    symbol: '$'

numeral.language 'en-PR',
  delimiters:
    thousands: ' ',
    decimal: '.'
  abbreviations:
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  ordinal: (number) ->
    return number is 1 ? 'st' : 'nd'
  currency:
    symbol: '$'

languageFromLocale = (locale) ->
  numeral.language(locale)

module.exports =
  languageFromLocale: languageFromLocale
  language: numeral.locales
